import React, { useState, useCallback } from 'react';
import FingerprintIcon from './shared/FingerprintIcon';

function base64urlToBuffer(base64url) {
  var padding = '='.repeat((4 - base64url.length % 4) % 4);
  var base64 = base64url.replace(/-/g, '+').replace(/_/g, '/') + padding;
  var binary = atob(base64);
  var bytes = new Uint8Array(binary.length);
  for (var i = 0; i < binary.length; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes.buffer;
}

function bufferToBase64url(buffer) {
  var bytes = new Uint8Array(buffer);
  var binary = '';
  for (var i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
}

function getCsrfToken() {
  var meta = document.querySelector('meta[name="csrf-token"]');
  return meta ? meta.getAttribute('content') : '';
}

function PasskeyAuthenticate(props) {
  var { authOptionsUrl, authenticateUrl, translations } = props;
  var [error, setError] = useState(null);
  var [authenticating, setAuthenticating] = useState(false);

  var handleAuthenticate = useCallback(function () {
    if (authenticating) return;

    setError(null);

    if (!window.PublicKeyCredential) {
      setError(translations.error_not_supported);
      return;
    }

    setAuthenticating(true);

    var csrfToken = getCsrfToken();

    fetch(authOptionsUrl, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken,
      },
      body: JSON.stringify({}),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Failed to get authentication options');
        return res.json();
      })
      .then(function (data) {
        var options = data.data;
        var challengeToken = options.challenge_token;

        var publicKeyOptions = {
          challenge: base64urlToBuffer(options.challenge),
          timeout: options.timeout,
          rpId: options.rpId,
          userVerification: options.userVerification,
        };

        if (options.allowCredentials && options.allowCredentials.length > 0) {
          publicKeyOptions.allowCredentials = options.allowCredentials.map(function (cred) {
            return {
              id: base64urlToBuffer(cred.id),
              type: cred.type,
              transports: cred.transports,
            };
          });
        }

        return navigator.credentials.get({ publicKey: publicKeyOptions }).then(function (credential) {
          return { credential: credential, challengeToken: challengeToken };
        });
      })
      .then(function (result) {
        var credential = result.credential;
        var challengeToken = result.challengeToken;

        var serialized = {
          id: credential.id,
          rawId: bufferToBase64url(credential.rawId),
          response: {
            authenticatorData: bufferToBase64url(credential.response.authenticatorData),
            clientDataJSON: bufferToBase64url(credential.response.clientDataJSON),
            signature: bufferToBase64url(credential.response.signature),
            userHandle: credential.response.userHandle
              ? bufferToBase64url(credential.response.userHandle)
              : null,
          },
          type: credential.type,
        };

        return fetch(authenticateUrl, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-Token': csrfToken,
          },
          body: JSON.stringify({
            credential: serialized,
            challenge_token: challengeToken,
          }),
        });
      })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (!data.success) throw new Error(data.message || 'Authentication failed');
        var redirectUrl = data.redirect_url || '/';
        if (window.Turbolinks) {
          Turbolinks.visit(redirectUrl);
        } else {
          window.location.href = redirectUrl;
        }
      })
      .catch(function (err) {
        setError(translations.error_generic);
        setAuthenticating(false);
      });
  }, [authenticating, authOptionsUrl, authenticateUrl, translations]);

  return (
    <div className="login-passkey">
      <button
        type="button"
        className="login-action login-action--secondary login-passkey__btn"
        onClick={handleAuthenticate}
        disabled={authenticating}
      >
        <span className="login-action__icon" aria-hidden="true">
          <FingerprintIcon size={18} />
        </span>
        <span>{authenticating ? translations.authenticating : translations.sign_in_passkey}</span>
      </button>

      {error && (
        <div className="login-passkey__error">{error}</div>
      )}
    </div>
  );
}

export default PasskeyAuthenticate;
